// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"3008b4f1","390":"9341e579","557":"9408365b","623":"eb27c1bc","660":"1a734912","676":"a66e3843","691":"3169f9da","747":"58fe08f7","936":"c3b31c1c","977":"7f5d3bec"}[chunkId] + ".chunk.js";
};